;
jQuery(function(){

    /**
     * Funcion para buscar la concesión en semovi por placa
     * (solo para taxis)
     */
    function ValidaSemovi(){
        $('#modal-zagruzka').modal('show');
        tipo = $('#tpConcesionTaxi').is(':checked') ? 'taxi' : 'ruta';
        $('#error-container').addClass('d-none');
        placa = $('#txPlaca').val();
        $.ajax({
            url: uConsultaSemovi+tipo+'/'+placa,
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json',
            data:'{"vin":"'+$('#txVIN').val()+'"}',
            success: function(data) {
                $('#valida-concesion').attr('disabled', true);
                $('#txPlaca').attr('disabled', true);
                $('#txVIN').attr('disabled', true);
                $('.valida-veh-radio').attr('disabled', true);

                $('#operators-section').removeClass('d-none');
                if(data.data.operadores.length > 0){
                    $('#operadores-table-body').find('tr:first').remove(); // quitar el "no data available"
                    $('#operators-table').removeClass('d-none');
                    $('#no-operators').addClass('d-none');
                    for(x=0;x<data.data.operadores.length;x++){
                        tr = '<tr>';
                        tr+= '<td>'+(x+1)+'</td>';
                        tr+= '<td>'+(data.data.operadores[x].curp_licencia||data.data.operadores[x].tx_curp)+'</td>';
                        tr+= '<td>'+(data.data.operadores[x].nombre||data.data.operadores[x].tx_nombre)+'</td>';
                        tr+= '<td>'+(data.data.operadores[x].primer_apellido||data.data.operadores[x].tx_primer_apellido)+'</td>';
                        tr+= '<td>'+(data.data.operadores[x].segundo_apellido||data.data.operadores[x].tx_segundo_apellido)+'</td>';
                        tr+= '<td>'+(data.data.operadores[x].tx_email||'')+'</td>';
                        tr+= '<td>'+(data.data.operadores[x].tx_telefono||'')+'</td>';
                        tr+= '<td class="bote"><i class="fa fa-trash asterisk" aria-hidden="true" title="Eliminar operador" role="button" curp="'+(data.data.operadores[x].curp_licencia||data.data.operadores[x].tx_curp)+'"></i></td>';
                        $('#operadores-table-body').append(tr);
                    }
                }
                $('#modal-zagruzka').modal('hide');

            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 401 || jqXHR.status === 419){
                    __crearMensaje(true,"Error","Tu sesión ha caducado");
                }else if(jqXHR.status === 418){
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }else{
                    $('#error-container').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    $('#error-container').removeClass('d-none');
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }
                $('#modal-zagruzka').modal('hide');
            }
        });
    }
    function ValidaSemoviBtn(){
        if(
            (/[A-Z0-9]{3,10}/.test($('#txPlaca').val()))
            && (/[A-Z0-9]{9,17}/.test($('#txVIN').val()))
            && ($('#tpConcesionTaxi').is(':checked') || $('#tpConcesionRuta').is(':checked'))
        ){
            $('#valida-concesion').attr('disabled', false);
            $('#add-concesion').removeClass('was-validated');
        }else{
            $('#valida-concesion').attr('disabled', true);
            $('#add-concesion').addClass('was-validated');
        }
    }




    /**
     * Campos que activan la búsqueda de concesión en Semovi
     */
    $('.valida-veh').on('keyup paste', function(e){
        ValidaSemoviBtn();
    });
    $('.valida-veh-radio').on('click', function(e){
        ValidaSemoviBtn();
    });

    $('#valida-concesion').on('click', function(e){
        ValidaSemovi();
    });




    /**
     * Tablas de la Aplicación
     */
    $('#main-table').dataTable( {
        paginate: false,
        bFilter: false,
        bInfo : false,
        ordering: false,
        language: {
            "sProcessing": "Procesando...",
            "sLengthMenu": "Mostrar _MENU_ registros",
            "sZeroRecords": "No se encontraron resultados",
            "sEmptyTable": "Ningún dato disponible en esta tabla",
            "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
            "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
            "sInfoPostFix": "",
            "sSearch": "Buscar:",
            "sUrl": "",
            "sInfoThousands": ",",
            "sLoadingRecords": "Cargando...",
            "oPaginate": {
                "sFirst": "Primero",
                "sLast": "Último",
                "sNext": "Siguiente",
                "sPrevious": "Anterior"
            },
            "oAria": {
                "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                "sSortDescending": ": Activar para ordenar la columna de manera descendente"
            },
            "buttons": {
                "copy": "Copiar",
                "colvis": "Visibilidad"
            }
        }
    });

    $('#table-operators').dataTable( {
        paginate: true,
        bFilter: true,
        bInfo : false,
        ordering: true,
        language: {
            "sProcessing": "Procesando...",
            "sLengthMenu": "Mostrar _MENU_ registros",
            "sZeroRecords": "No se encontraron resultados",
            "sEmptyTable": "Ningún dato disponible en esta tabla",
            "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
            "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
            "sInfoPostFix": "",
            "sSearch": "Buscar:",
            "sUrl": "",
            "sInfoThousands": ",",
            "sLoadingRecords": "Cargando...",
            "oPaginate": {
                "sFirst": "Primero",
                "sLast": "Último",
                "sNext": "Siguiente",
                "sPrevious": "Anterior"
            },
            "oAria": {
                "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                "sSortDescending": ": Activar para ordenar la columna de manera descendente"
            },
            "buttons": {
                "copy": "Copiar",
                "colvis": "Visibilidad"
            }
        }
    } );



    /**
     * Servicio de búsqueda de curp
     */
    $('#txCurpOperador').on('keyup', function (e) {
        if ($(this).val() != '' && /^(([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d))$/.test($(this).val())) {
            $.ajax({
                url: uCURP,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    tx_curp: $(this).val()
                }),
                success: function (data) {
                    $('#txOperadorNombres').val(data.txNombres);
                    $('#txOperadorPrimerApellido').val(data.txApellidoPaterno);
                    $('#txOperadorSegundoApellido').val(data.txApellidoMaterno);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    err = jqXHR.status == 419 ? 'Tu sesión ha caducado, por favor inicia sesión de nuevo' : jqXHR.responseJSON.message || jqXHR.responseJSON.respuesta;
                    $('#txOperadorNombres').val('');
                    $('#txOperadorPrimerApellido').val('');
                    $('#txOperadorSegundoApellido').val('');
                    __crearMensaje(true, "Error", err);
                }
            });
        }else{
            $('#txOperadorNombres').val('');
            $('#txOperadorPrimerApellido').val('');
            $('#txOperadorSegundoApellido').val('');
        }
    });



    /**
     * Boton de agregar opeador
     */
    $('#add-operador').on('click', function(e){
        form = document.getElementById('add-concesion');
        if (form.checkValidity() === true) {
            $('#modal-zagruzka').modal('show');
            $('#add-operador').attr('disabled', true);
            $('#error-op-container').addClass('d-none');
            $.ajax({
                url: uOperadorSesion,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data:'{"txCurp":"'+$('#txCurpOperador').val()+'", "txCorreo":"'+$('#txOperadorEmail').val()+'", "txTelefono":"'+$('#txOperadorTelefono').val()+'"}',
                success: function(data) {
                    $('#txCurpOperador').val('');
                    $('#txOperadorEmail').val('');
                    $('#txOperadorTelefono').val('');
                    $('#txOperadorNombres').val('');
                    $('#txOperadorPrimerApellido').val('');
                    $('#txOperadorSegundoApellido').val('');
                    $('#add-concesion').removeClass('was-validated');
    
                    $('#operators-section').removeClass('d-none');
                    $('#operators-table').removeClass('d-none');
                    if(data.data.cuantos == 1){
                        //$('#operadores-table-body').find('tr:first').remove(); // quitar el "no data available"
                        $('#main-table').removeClass('d-none');
                        $('#no-operators').addClass('d-none');
                    }
                    tr = '<tr>';
                    tr+= '<td>'+(data.data.cuantos)+'</td>';
                    tr+= '<td>'+data.data.operador.tx_curp+'</td>';
                    tr+= '<td>'+data.data.operador.tx_nombre+'</td>';
                    tr+= '<td>'+data.data.operador.tx_primer_apellido+'</td>';
                    tr+= '<td>'+data.data.operador.tx_segundo_apellido+'</td>';
                    tr+= '<td>'+data.data.operador.tx_email+'</td>';
                    tr+= '<td>'+data.data.operador.tx_telefono+'</td>';
                    tr+= '<td class="bote"><i class="fa fa-trash asterisk" aria-hidden="true" title="Eliminar operador" role="button" curp="'+data.data.operador.tx_curp+'"></i></td>';
                    $('#operadores-table-body').append(tr);
                    $('#add-operador').attr('disabled', false);
                    $('#modal-zagruzka').modal('hide');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-op-container').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-op-container').removeClass('d-none');
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                    $('#add-operador').attr('disabled', false);
                    $('#modal-zagruzka').modal('hide');
                }
            });
        }
        $('#add-concesion').addClass('was-validated');
    });



    /**
     * Boton para enviar el formulario y guardar concesion/ops
     * 
     */
    $('#btn-guardar-conce').on('click', function(e){
        $.ajax({
            url: ucg,
            dataType: 'json',
            type: 'POST',
            contentType: 'application/json',
            data:'{"foo":"bar"}',
            success: function(data) {
                location.href = ucga;
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 401 || jqXHR.status === 419){
                    __crearMensaje(true,"Error","Tu sesión ha caducado");
                }else if(jqXHR.status === 418){
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }else{
                    __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                }
            }
        });
    });



    /**
     * Boton de eliminar opeador
     */
     $('#operadores-table-body').on('click','i', function(e){
        curp = $(this).attr('curp');
        o = $(this);
        if (window.confirm('¿Deseas eliminar al operador?')) {
            
            $.ajax({
                url: uOperadorSesionB,
                dataType: 'json',
                type: 'DELETE',
                contentType: 'application/json',
                data:'{"txCurp":"'+curp+'"}',
                success: function(data) {
                    o.closest('tr').remove();
                    if(data.cuantos==0){
                        $('#operators-table').addClass('d-none');
                        $('#no-operators').removeClass('d-none'); 
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-op-container').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-op-container').removeClass('d-none');
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                    $('#add-operador').attr('disabled', false);
                }
            });
        }
    });




    /**
     * Botón de eliminar concesion (user)
     * borra-concesion-u
     */
     $('.borra-concesion-u').on('click', function(e){
        i = parseInt($(this).attr('i'));
        if (window.confirm('¿Deseas eliminar esta concesión?')) {
            $('#d-c-'+i).trigger('submit');
        }
    });



    /**
     * Botones de Agregar, editar, eliminar operador en admin operadores
     * 
     */
    $('#app-operadores').on('click', '.btn-admin-op', function(e){
        kual = $(this).attr('id');
        $('#error-add-op').addClass('d-none');
        o = parseInt($(this).attr('op'));
        $('#idOp').val(o);
        $('#txCurpOperador').val('');
        $('#txOperadorNombres').val('');
        $('#txOperadorPrimerApellido').val('');
        $('#txOperadorSegundoApellido').val('');
        $('#txOperadorEmail').val('');
        $('#txOperadorTelefono').val('');
        //Select mode (edit or readonly)
        switch(kual){
            case 'btn-edita-operador':{
                $('#txCurpOperador').attr('disabled', true);
                $('#txOperadorEmail').attr('disabled', false);
                $('#txOperadorTelefono').attr('disabled', false);
                $('#btnSaveOp').attr('disabled', false);
                $('#btnSaveOp').removeClass('d-none');
                $('#btnDontSaveOp').text('Cancelar');
                $('#whatever').text('Editar operador');
                $('#frmAddOperadorConce').removeClass('was-validated');
                break;
            }
            case 'btn-add-operador':{
                $('#txCurpOperador').attr('disabled', false);
                $('#txOperadorEmail').attr('disabled', false);
                $('#txOperadorTelefono').attr('disabled', false);
                $('#btnSaveOp').attr('disabled', false);
                $('#btnSaveOp').removeClass('d-none');
                $('#btnDontSaveOp').text('Cancelar');
                $('#whatever').text('Agregar operador');
                $('#frmAddOperadorConce').removeClass('was-validated');
                break;
            }
            default:{
                $('#txCurpOperador').attr('disabled', true);
                $('#txOperadorEmail').attr('disabled', true);
                $('#txOperadorTelefono').attr('disabled', true);
                $('#btnSaveOp').attr('disabled', true);
                $('#btnSaveOp').addClass('d-none');
                $('#btnDontSaveOp').text('Cerrar');
                $('#whatever').text('Detalles del operador');
                break;
            }
        }

        if(kual == 'btn-borra-operador'){
            if(window.confirm('¿Estás seguro que deseas eliminar el operador asociado a la concesión?')){
                $.ajax({
                    url: uOperadorConcesionB,
                    dataType: 'json',
                    type: 'DELETE',
                    contentType: 'application/json',
                    data:'{"id":"'+$('#idOp').val()+'"}',
                    success: function(data) {
                        oTr = $('#operador-'+$('#idOp').val());
                        $('#table-operators').DataTable().row().remove(oTr).draw();
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        if(jqXHR.status === 401 || jqXHR.status === 419){
                            __crearMensaje(true,"Error","Tu sesión ha caducado");
                        }else if(jqXHR.status === 418){
                            __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        }else{
                            __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        }
                    }
                });
            }
        }else{
            $.ajax({
                url: uConsultaOperador,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data:'{"id":"'+o+'"}',
                success: function(data) {
                    if(null!=data.operador){
                        $('#txCurpOperador').val(data.operador.tx_curp);
                        $('#txOperadorNombres').val(data.operador.tx_nombre);
                        $('#txOperadorPrimerApellido').val(data.operador.tx_primer_apellido);
                        $('#txOperadorSegundoApellido').val(data.operador.tx_segundo_apellido);
                        $('#txOperadorEmail').val(data.operador.tx_email);
                        $('#txOperadorTelefono').val(data.operador.tx_telefono);
                    }
                    $('#modal-operador').modal('show');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                }
            });
        }

    });



    /**
     * Boton para agregar operador a una concesion existente
     * 
     */
     $('#btnSaveOp').on('click', function(e){
        $('#error-add-op').addClass('d-none');
        form = document.getElementById('frmAddOperadorConce');
        if (form.checkValidity() === true) {
            $('#add-operador').attr('disabled', true);
            $('#error-op-container').addClass('d-none');
            $.ajax({
                url: uOperadorConcesion,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data:'{"id":"'+$('#idOp').val()+'","txCurp":"'+$('#txCurpOperador').val()+'","txCorreo":"'+$('#txOperadorEmail').val()+'","txTelefono":"'+$('#txOperadorTelefono').val()+'"}',
                success: function(data) {
                    $('#txCurpOperador').val('');
                    $('#txOperadorEmail').val('');
                    $('#txOperadorTelefono').val('');
                    $('#txOperadorNombres').val('');
                    $('#txOperadorPrimerApellido').val('');
                    $('#txOperadorSegundoApellido').val('');
                    $('#add-concesion').removeClass('was-validated');
    
                    if(parseInt($('#idOp').val())===0){
                        tr = '<tr id="operador-'+data.data.operador.id+'">';
                        tr+= '<td>'+data.data.operador.tx_nombre+' ';
                        tr+= ''+data.data.operador.tx_primer_apellido+' ';
                        tr+= ''+data.data.operador.tx_segundo_apellido+'</td>';
                        
                        tr+= '<td>';
                        tr+='<button id="btn-ver-operador" op="'+data.data.operador.id+'" type="button" class="btn-admin-op btn btn-cdmx btn-shadow p-1"><span class="fa fa-eye"></span> Ver</button>';
                        tr+='<button id="btn-edita-operador" op="'+data.data.operador.id+'" type="button" class="btn-admin-op btn btn-cdmx-amarillo btn-shadow p-1"><span class="fa fa-edit"></span> Editar</button>';
                        tr+='<button id="btn-borra-operador" op="'+data.data.operador.id+'" type="button" class="btn-admin-op btn btn-cdmx-rojo btn-shadow p-1"><span class="fa fa-trash"></span> Eliminar</button>';
                        tr+='</td></tr>';
                        oTr = $(tr);
                        $('#table-operators').DataTable().row.add(oTr).draw();
                    }
                    $('#add-operador').attr('disabled', false);
                    $('#modal-operador').modal('hide');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if(jqXHR.status === 401 || jqXHR.status === 419){
                        __crearMensaje(true,"Error","Tu sesión ha caducado");
                    }else if(jqXHR.status === 418){
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }else{
                        $('#error-add-op').text(jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                        $('#error-add-op').removeClass('d-none');
                        __crearMensaje(true,"Error",jqXHR.responseJSON.mensaje||jqXHR.responseJSON.message);
                    }
                    $('#add-operador').attr('disabled', false);
                }
            });
        }
        $('#frmAddOperadorConce').addClass('was-validated');

        
    });

});
